import _ from 'lodash';
export default {
    debug: true,

    state: {
        ingredients: []
    },

    addIngredient(ingredient, params = null) {
        if(this.debug) {
            console.log('Adding ingredient:', ingredient.label);
        }

        if(params === null) {
            params = {
                treatment: null,
                unit_id: null,
                amount: null
            }
        }

        params.ingredient = ingredient;

        this.state.ingredients.push(params);
    },

    getIngredient(index) {
        return this.state.ingredients[index];
    },

    removeIngredient(index) {
        if(this.debug) {
            console.log('Removing ingredient:', index);
        }
        this.state.ingredients.splice(index, 1);
    },

    attachToTreatment(index, treatment) {
        this.state.ingredients[index].treatment = treatment;
    },

    detach(index) {
        this.state.ingredients[index].treatment = null;
    },
    getIngredientUnitString(ingredient) {
        console.log(ingredient)

        let unit = _.find(ingredient.ingredient.units.data, {id: ingredient.unit_id});

        return unit.unit;
    }
};
